<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                modalWidth="90%"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Nombre')">
                <a-input
                  v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Acción del rol" key="1">
          <mantenimiento-role-node-action v-if="idForm" :name="idForm"></mantenimiento-role-node-action>
          <span v-else>Seleccione un usuario para ver más.</span>
        </a-tab-pane>
        <a-tab-pane tab="Usuarios" key="2">
          <mantenimiento-usuarios-por-rol v-if="idForm" :name="idForm"></mantenimiento-usuarios-por-rol>
          <span v-else>Seleccione un usuario para ver más.</span>
        </a-tab-pane>
        <a-tab-pane tab="Role report" key="3">
          <mantenimiento-reportes-por-rol v-if="idForm" :name="idForm"></mantenimiento-reportes-por-rol>
          <span v-else>Seleccione un usuario para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'role',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'name'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'name', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'}
          ]
        }
      }
    },
    computed: {
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].name : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/Role.vue